

<script>
import FlowList from "./components/FlowList.vue";
import FlowTemplate from "./components/FlowTemplate.vue";
import TemplateManage from "./components/TemplateManage.vue";

export default {
  name: "Assist",
  components: {
    FlowList,
    FlowTemplate,
    TemplateManage,
  },
  data() {
    return {
      componentKey: "FlowList",
    };
  },
  computed: {},
  methods: {
    getOptions() {
      const optionList = [
        { key: "FlowList", desc: "备课内容" },
        { key: "FlowTemplate", desc: "一级菜单模板" },
        { key: "TemplateManage", desc: "二级菜单模板" },
      ];
      return optionList;
    },
    changeComponentKey(key) {
      this.componentKey = key;
    },
  },
};
</script>
<template>
  <div class="container">
    <div class="options">
      <template v-for="item in getOptions()">
        <div
          :key="item.key"
          :class="componentKey===item.key?'item_option-active':''"
          class="item_option"
          @click="changeComponentKey(item.key)">{{ item.desc }}</div>
      </template>
    </div>
    <component
      :is="componentKey"
      class="component_item"/>
  </div>
</template>

<style scoped>
.container {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.item_option {
  padding: 20px;
  margin-bottom: 20px;
  background: white;
}
.item_option:hover{
  background: rgba(220, 220, 220, 0.4);
}
.item_option-active {
  background: rgb(220, 220, 220);
}
.component_item{
  width: 70%;
  margin-right: 20%;
}
</style>
